import type { CsvIntegrationConfig } from '@entities/platform-entities/integration/csv-integration-config.interface';

import { CSV_REQUIRED_TERRIFIC_FIELDS } from './csv-required-terrific-fields';

export function validateCsvIntegrationConfig(config: CsvIntegrationConfig | undefined): string[] {
  if (!config) {
    return ['csvIntegrationConfig is required for GenericCsvCustom'];
  }

  const errors: string[] = [];

  for (const field of CSV_REQUIRED_TERRIFIC_FIELDS) {
    if (!config.fieldMapping[field]) {
      errors.push(`Missing required field mapping: ${field}`);
    }
  }

  const { strategy, customField } = config.variantGrouping ?? { strategy: undefined };

  if (!strategy) {
    errors.push('variantGrouping.strategy is required');
  }

  if (strategy === 'title' && !config.fieldMapping.title) {
    errors.push('fieldMapping.title is required when variant grouping strategy is title');
  }

  if (strategy === 'description' && !config.fieldMapping.description) {
    errors.push(
      'fieldMapping.description is required when variant grouping strategy is description'
    );
  }

  if (strategy === 'externalUrl' && !config.fieldMapping.externalUrl) {
    errors.push(
      'fieldMapping.externalUrl is required when variant grouping strategy is externalUrl'
    );
  }

  if (strategy === 'customField' && !customField) {
    errors.push('variantGrouping.customField is required when strategy is customField');
  }

  return errors;
}
